import React, { useEffect, useState } from 'react'

import Components from '../../../components'
import Client from '../../../services'
import EnrollCourse from './EnrollCourse'
import NewExamForm from './NewExamForm'

const studentTableheaderMap = {
    "index": {label: "Sl.No.",},
    "_id": {label: "Enrollment Id",},
    "username": {label: "Student Id",},
    "name": {label: "Name",},
}

const examTableheaderMap = {
    "index": {label: "Sl.No.",},
    "title": {label: "Name",},
    "fullMarks": {label: "Full Marks"},
    nQuestions: {label: "No. of Questions"},
    duration: {label: "duration"},
    "_by": {label: "Created By",},
    "createdAt": {label: "Created At"}
}

class CourseDetails extends React.Component{
    state = {
        creator: {},
        school: {},
        course: {},
        students: [],
        exams: []
    }
    componentDidMount(){
        this.loadDetails()
        this.loadStudents()
        this.loadExams()
    }

    loadDetails = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/common/course/${id}`)
        if(success){
            const {_by: creator, _sid: school, ...course} = data
            console.log({ creator, course})
            this.setState({
                creator, course
            })
        }else{
            Client.alert.fire({
                icon: "failure",
                title: "Loading failed",
                body: message,
                confirmButton: true,
            })
        }
    }

    loadExams = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/management/exam/list?_cid=${id}`)
        if(success){
            console.log(data)
            const list = data.map((v, i) => {
                return {
                    index: i+1,
                    title: v.title,
                    fullMarks: v.fullMarks,
                    nQuestions: v.nQuestions,
                    duration: v.examDuration,
                    createdAt: new Date(v.createdAt).toLocaleString(),
                    _by: <>
                        <div>
                            {v._by.name}
                        </div>
                        <div>
                            {v._by.username}
                        </div>
                    </>
                }
            })
            console.log({exam: list})
            this.setState({
                exams: list
            })
        }
    }

    loadStudents = async () => {
        const {id} = this.props.match.params
        const {success, data, message} = await Client.api.get(`/management/course/${id}/students`)
        if(success){
            const list = data.map((v, i) => {
                return {
                    index: i+1,
                    _id: v._id,
                    name: v._uid.name,
                    username: v._uid.username,
                }
            })
            this.setState({
                students: list
            })
        }
    }

    handleEnrollStudent = (e) => {
        e.preventDefault()
        let studentId = ""
        let feesDueDate = ""
        let monthlyFees = this.state.course.cost
        const handleClickStudent = (id) => studentId = id
        const handleChangeFirstDueDate = (value) => feesDueDate = value
        const handleChangeMonthlyFees = (value) => monthlyFees = value
        Client.alert.fire({
            title: "Enroll Student",
            body: <EnrollCourse 
                courseFees={this.state.course.cost}
                onChangeMonthlyFees={handleChangeMonthlyFees}
                onClickStudent={handleClickStudent} 
                courseStartingFrom={Client.utility.getFormattedDateYYYYMMDD(this.state.course.startingFrom)}
                onChageDueDate={handleChangeFirstDueDate}
            />,
            confirmButton: true,
            cancelButton: true,
            confirmButtonText: "Submit",
            preConfirm: async () => {
                const {batch} = this.state
                const {id} = this.props.match.params

                const payload = {
                    studentId: studentId.trim(),
                    courseId: id.trim(),
                    feesDueDate,
                    monthlyFees
                }
                const {success, data, message} = await Client.api.post(`/management/student/enroll`, payload)
                if (success){
                    const newEnrollment = {
                        index: this.state.students.length + 1,
                        _id: data.courseEnrollment._id,
                        username: data.courseEnrollment._uid.username,
                        name: data.courseEnrollment._uid.name,
                    }
                    this.setState({students: [...this.state.students, newEnrollment]})
                    await Client.alert.fire({
                        title: "Success",
                        body: message || "Student enrolled succesfully.",
                        confirmButton: true,
                    })
                    
                }else{
                    Client.alert.fire({
                        title: "Failed",
                        body: message || "failed to enroll student.",
                        confirmButton: true
                    })
                }
            }
        })
    }

    handleNewExam = (e) => {
        e.preventDefault()
        const inputs = {
            title: "",
            fullMarks: "100",
            nQuestions: "10",
            examDuration: "60",
        }
        
        const handleFieldChange = (name, value) => {
            inputs[name] = value
        }

        Client.alert.fire({
            title: "Create New Exam",
            body: <NewExamForm 
                course={this.state.course}
                onChange={handleFieldChange}
            />,
            confirmButton: true,
            cancelButton: true,
            confirmButtonText: "Submit",
            preConfirm: async () => {
                const payload = {
                    ...inputs,
                    fullMarks: Number(inputs.fullMarks),
                    nQuestions: Number(inputs.nQuestions),
                    examDuration: Number(inputs.examDuration),
                    _cid: this.state.course._id
                }
                console.log(payload);
                const {success, data, message} = await Client.api.post(`/management/exam/new`, payload)
                if (success){
                    
                    await Client.alert.fire({
                        title: "Success",
                        body: message || "Exam created succesfully.",
                        confirmButton: true,
                    })
                    
                }else{
                    Client.alert.fire({
                        title: "Failed",
                        body: message || "failed to create exam.",
                        confirmButton: true
                    })
                }
            }
        })
    }

    handleCreateNewBatch = () => {
        const {id} = this.props.match.params
        this.props.history.push('/management/course-batch/create?cid='+id)
    }

    render(){
        const studentTableHeaderCols = ["index", "_id", "username", "name"]
        const examTableHeaderCols = ["index", "title", "fullMarks", "nQuestions", "duration", "_by", "createdAt"]
        const {school, course} = this.state
        return <div className="student-batch-details">
            <h2>Course Details</h2>
            <Components.buttons.FlatButton onClick={this.handleCreateNewBatch}>Create new batch</Components.buttons.FlatButton>
            <Components.buttons.FlatButton onClick={this.handleEnrollStudent}>Enroll New Student</Components.buttons.FlatButton>
            <Components.buttons.FlatButton onClick={this.handleNewExam}>New Exam</Components.buttons.FlatButton>
            <div>Institution Name: {school.name}</div>
            <div>Address: {school.address}</div>
            <div>Batch Title: {course.title}</div>
            <div>Batch Description: {course.description}</div>
            <div>Starting Date: {course.startingFrom}</div>
            <div>No of Levels: {course.nLevel}</div>
            <div>Duration of each level: {course.duration} month</div>
            <div>Cost per month: Rs. {course.cost}/-</div>

            <section>
                <div>Student List</div>
                <Components.data.Table
                    headerMap={studentTableheaderMap}
                    headers={studentTableHeaderCols}
                    data={this.state.students}
                />
            </section>
            <section>
                <div>Exam List</div>
                <Components.data.Table 
                    headerMap={examTableheaderMap}
                    headers={examTableHeaderCols}
                    data={this.state.exams}
                />
            </section>

        </div>
    }
}

export default CourseDetails